// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { ProcessedInteractions, Interactions, User } = initSchema(schema);

export {
  ProcessedInteractions,
  Interactions,
  User
};